var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_03_Checkmark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_03_Checkmark",
    clipPath: "url(#clip-Icons_Selected_03_Checkmark)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckmarkDavidSelected",
    transform: "translate(-9.4 5.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(84.23 52.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 262.585,
    cy: 262.585,
    r: 262.585,
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000024688917951254936150000008386693706061424544_",
    transform: "translate(9.4 11.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M175.1,391.22C293.807,320.472,423.4,202.1,533.263,115.71c-17.347-18.027-35.374-51.361-52.721-69.048C477.48,43.6,474.079,40.2,469.657,40.2c-3.741,0-7.483,2.381-10.544,4.762-88.776,68.367-174.49,170.408-272.789,224.83-5.1,2.721-10.884,5.442-16.667,4.082-5.1-1.361-8.844-5.442-12.245-9.524-14.966-18.027-24.49-40.136-39.116-58.5-7.483-9.184-13.265-13.605-18.707-14.966-9.864-2.381-19.048,5.782-33.673,17.347-12.585,9.864-26.531,17.687-39.116,27.551,36.735,34.694,81.293,100.34,118.027,135.034,4.082,4.082,14.966,20.408,20.748,21.088",
    transform: "translate(32.384 56.058)",
    fill: "#79de75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M277.087,547.274C129.468,547.274,9.4,427.206,9.4,279.587S129.468,11.9,277.087,11.9A266.326,266.326,0,0,1,466.543,90.471a8.418,8.418,0,0,1-11.9,11.9A249.845,249.845,0,0,0,277.087,28.907c-138.435,0-251.02,112.585-251.02,251.02s112.585,251.021,251.02,251.021,251.02-112.585,251.02-251.021a8.058,8.058,0,0,1,8.163-8.163,8.277,8.277,0,0,1,8.163,8.163c.68,147.279-119.728,267.347-267.347,267.347",
    transform: "translate(-9.4 -11.9)",
    fill: "#4c4c4c"
  }))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_03_Checkmark.9dd45b07.svg";
export { SvgComponent as ReactComponent };